import { environment } from '../../environments/environment';

export const ADMIN_API_URLS = {
    ADMIN_OFFERS: environment.apiUrl + '/secure/offers'
};
